import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/ds/shadcn/components/ui/select";
import { Spinner } from "@/ds/shadcn/components/ui/spinner";
import type { Option } from "@/lib/common/Option";
import type { LucideIcon } from "lucide-react";
import { createElement } from "react";

export interface SelectorProps<T extends string> {
	icon?: LucideIcon;
	className?: string;
	placeholder: string;
	options: Option<T>[];
	value: T | null;
	onChange: (value: T) => void;
	isLoading?: boolean;
	disabled?: boolean;
}

export const Selector = <T extends string>(props: SelectorProps<T>): React.JSX.Element => {
	const {
		icon,
		className,
		placeholder,
		options,
		value,
		onChange,
		isLoading = false,
		disabled = false
	} = props;

	return (
		<Select value={value === null ? "" : value} onValueChange={onChange} disabled={disabled}>
			<SelectTrigger className={className}>
				{icon && createElement(icon)}
				{
					isLoading
						? <Spinner />
						: <SelectValue placeholder={placeholder} />
				}
			</SelectTrigger>
			<SelectContent>
				{
					options.map(x => (
						<SelectItem key={x.value} value={x.value}>{x.label}</SelectItem>
					))
				}
			</SelectContent>
		</Select>
	);
};
